<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8745 16.9526V13.2025C11.8745 13.0368 11.8087 12.8778 11.6915 12.7606C11.5743 12.6434 11.4153 12.5775 11.2495 12.5775H8.74954C8.58378 12.5775 8.42481 12.6434 8.3076 12.7606C8.19039 12.8778 8.12454 13.0368 8.12454 13.2025V16.9526C8.12454 17.1184 8.0587 17.2773 7.94151 17.3945C7.82432 17.5117 7.66537 17.5776 7.49962 17.5776L3.75008 17.5781C3.668 17.5781 3.58671 17.562 3.51088 17.5306C3.43504 17.4992 3.36613 17.4531 3.30809 17.3951C3.25004 17.337 3.204 17.2681 3.17258 17.1923C3.14117 17.1165 3.125 17.0352 3.125 16.9531V9.72965C3.125 9.64257 3.14319 9.55646 3.17842 9.47682C3.21364 9.39719 3.26511 9.3258 3.32954 9.26722L9.57911 3.58481C9.69415 3.48021 9.84406 3.42225 9.99955 3.42224C10.155 3.42224 10.3049 3.48019 10.42 3.58479L16.6704 9.26722C16.7349 9.3258 16.7863 9.39719 16.8216 9.47683C16.8568 9.55647 16.875 9.64259 16.875 9.72967V16.9531C16.875 17.0352 16.8588 17.1165 16.8274 17.1923C16.796 17.2681 16.75 17.337 16.6919 17.3951C16.6339 17.4531 16.565 17.4992 16.4891 17.5306C16.4133 17.562 16.332 17.5781 16.2499 17.5781L12.4995 17.5776C12.3337 17.5776 12.1748 17.5117 12.0576 17.3945C11.9404 17.2773 11.8745 17.1184 11.8745 16.9526V16.9526Z"
      stroke-opacity="0.6"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
